import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import OfflineBanner from "@/components/OfflineBanner";
import { ThemeProvider } from "@/components/theme-provider";
import { useGlobalHaptics } from "@/hooks/use-global-haptics";
import { SpeedInsights } from "@vercel/speed-insights/react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const AppContainer = () => {
  // Inject global haptics for interactive elements
  useGlobalHaptics();

  return (
    <ThemeProvider defaultTheme="dark" storageKey="servizhub-theme">
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <OfflineBanner />
          <Toaster />
          <Sonner position="top-center" duration={3000} expand={true} richColors />
          <main>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Index />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </main>
          <SpeedInsights />
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

const App = () => (
  <ErrorBoundary>
    <AppContainer />
  </ErrorBoundary>
);

export default App;
